import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { getCapaianKinerjaGubernur_act } from '../../../redux/ducks/cpkgubernur/actions'
import Layout from '../../components/Layout'
import { useParams } from 'react-router-dom'
import BackButton from '../../components/BackButton'
import TableSakip from './TableSakip';
import TableSakinah from './TableSakinah';


const CapaianKinerjaGubernur = (props) => {
    const { yearconfig } = useParams()
    const dataBreadcrumb = [
        {
            title: 'Home',
            isActive: true,
            goTo: '/tahun/'+yearconfig,
        },
        {
            title: 'Capaian PK Gubernur',
            isActive: false,
            goTo: '',
        }
    ]
    const triwulan = ["tw1", "tw2", "tw3", "tw4"]
    React.useEffect(() => {
        props.getCapaianKinerjaGubernur(yearconfig)
    }, [yearconfig])
    return (
        <Layout 
            loading={props.CapaianKinerjaGubernur.loadingGet}
            dataBreadcrumb={dataBreadcrumb}
        >
            <div className='bg-white rounded-lg drop-shadow-2xl py-5 px-2 w-full'>
                <div className="flex-grow bg-white rounded-xl py-2 relative">
                    <h1 className="mb-1 text-2xl font-bold text-center text-primeColor1">Capaian Perjanjian Kinerja Gubernur</h1>
                    <h1 className="mb-1 text-md font-bold text-center text-secondaryColor1">
                        Tahun {yearconfig}
                    </h1>
                    <hr className="mb-3" />
                </div>
                {yearconfig > 2025 ? <TableSakinah dataTable={props.CapaianKinerjaGubernur?.data} /> : <TableSakip dataTable={props.CapaianKinerjaGubernur?.data} />}
                <div className="w-full px-10">
                </div>
            </div>
            <BackButton backLink={`/tahun/${yearconfig}`} />
        </Layout>
    )
}

const mapStateToProps = (state) => ({
    CapaianKinerjaGubernur: state.cpkgubernurState.CapaianKinerjaGubernur
})

const mapDispatchToProps = {
    getCapaianKinerjaGubernur: getCapaianKinerjaGubernur_act
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default compose(withConnect, React.memo)(CapaianKinerjaGubernur)

